










import { Component, Vue, Prop, Inject } from 'vue-property-decorator'
import { Swipe, SwipeItem } from 'vant'
import { viewImage } from '@utils/image'

@Component({
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem
  }
})
export default class BannerSection extends Vue {
  @Prop({ default: () => [] }) readonly banners!: Array<any>

  bannerClick(item: any) {
    this.$emit('bannerClick',item)
    location.href = item.linkUrl
  }

  get imgUrl() {
    return (item: any) => {
      return viewImage(item.iconUrl, 702, 148)
    }
  }

  get bannerAry() {
    if (this.banners.length > 8) {
      //最多显示八张
      return this.banners.slice(0, 8)
    }
    return this.banners
  }
}
